export default "__VITE_ASSET__yF8OfPMU__"